// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#crypto-content {
  margin-left: 2vw;
  margin-right: 2vw;
  display: grid;
  padding: 0.2% 0.6% 0.3%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px 0 rgba(0, 0, 0, 0.2),
    0 6px 20px 0 rgba(0, 0, 0, 0.19);
  min-height: 100vh;
  width: auto;
}
.crypto-conteiner {
  display: grid;
  grid-template-rows: auto 1fr;
  align-items: start;
  height: 100%;
  width: 100%;
  min-width: 0;
}

.crypto-mainsubtitle {
      position: relative;
    left: 0.5vw;
    font-family: "Amatic SC";
    font-size: 3vw;
    text-align: center;
}

.crypto-titleGame {
  display: grid;
  grid-template-columns: auto 1.5vw;
}
.crypto-game-wrapper{
  display: grid;
  grid-template-columns: 76% auto;
  gap: 2vw;
}

.crypto-fullscreen {
    display: grid;
    height: 1.5vw;
    justify-self: end;
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/Сrypto/styles/CryptoApp.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,yDAAgE;EAChE;;oCAEkC;EAClC,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;MACM,kBAAkB;IACpB,WAAW;IACX,wBAAwB;IACxB,cAAc;IACd,kBAAkB;AACtB;;AAEA;EACE,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;IACI,aAAa;IACb,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB","sourcesContent":["#crypto-content {\n  margin-left: 2vw;\n  margin-right: 2vw;\n  display: grid;\n  padding: 0.2% 0.6% 0.3%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px 0 rgba(0, 0, 0, 0.2),\n    0 6px 20px 0 rgba(0, 0, 0, 0.19);\n  min-height: 100vh;\n  width: auto;\n}\n.crypto-conteiner {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  align-items: start;\n  height: 100%;\n  width: 100%;\n  min-width: 0;\n}\n\n.crypto-mainsubtitle {\n      position: relative;\n    left: 0.5vw;\n    font-family: \"Amatic SC\";\n    font-size: 3vw;\n    text-align: center;\n}\n\n.crypto-titleGame {\n  display: grid;\n  grid-template-columns: auto 1.5vw;\n}\n.crypto-game-wrapper{\n  display: grid;\n  grid-template-columns: 76% auto;\n  gap: 2vw;\n}\n\n.crypto-fullscreen {\n    display: grid;\n    height: 1.5vw;\n    justify-self: end;\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
